module.exports = __webpack_public_path__ + "img/home3.28dd77dd.svg";